interface SEOHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl?: string;
  ogType?: string;
  ogImage?: string;
  articlePublishedTime?: string;
  articleModifiedTime?: string;
  articleAuthor?: string;
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl = 'https://young-mama.com',
  ogType = 'website',
  ogImage = 'https://readdy.ai/api/search-image?query=Warm%20and%20cozy%20motherhood%20parenting%20website%20with%20soft%20cream%20and%20blush%20aesthetic%2C%20gentle%20illustrations%20style%2C%20minimal%20clean%20design%2C%20warm%20inviting%20atmosphere&width=1200&height=630&seq=og-default&orientation=landscape',
  articlePublishedTime,
  articleModifiedTime,
  articleAuthor,
}: SEOHeadProps) {
  useEffect(() => {
    document.title = title;
    const metaTags: Record<string, { name?: string; property?: string; content: string }> = {
      description: { name: 'description', content: description },
      keywords: { name: 'keywords', content: keywords },
      'og:title': { property: 'og:title', content: title },
      'og:description': { property: 'og:description', content: description },
      'og:type': { property: 'og:type', content: ogType },
      'og:image': { property: 'og:image', content: ogImage },
      'og:url': { property: 'og:url', content: canonicalUrl },
      'og:locale': { property: 'og:locale', content: 'zh_CN' },
      'og:site_name': { property: 'og:site_name', content: '年轻的妈妈' },
      'twitter:card': { name: 'twitter:card', content: 'summary_large_image' },
      'twitter:title': { name: 'twitter:title', content: title },
      'twitter:description': { name: 'twitter:description', content: description },
      'twitter:image': { name: 'twitter:image', content: ogImage },
    };

    if (articlePublishedTime) {
      metaTags['article:published_time'] = { property: 'article:published_time', content: articlePublishedTime };
    }
    if (articleModifiedTime) {
      metaTags['article:modified_time'] = { property: 'article:modified_time', content: articleModifiedTime };
    }
    if (articleAuthor) {
      metaTags['article:author'] = { property: 'article:author', content: articleAuthor };
    }

    const existingMeta = new Map<string, HTMLMetaElement>();
    document.head.querySelectorAll('meta[name], meta[property]').forEach((el) => {
      const key = el.getAttribute('name') || el.getAttribute('property');
      if (key) existingMeta.set(key, el as HTMLMetaElement);
    });

    Object.entries(metaTags).forEach(([key, attrs]) => {
      const attrKey = attrs.name || attrs.property || '';
      const el = existingMeta.get(attrKey);
      if (el) {
        el.setAttribute('content', attrs.content);
        existingMeta.delete(attrKey);
      } else {
        const newMeta = document.createElement('meta');
        if (attrs.name) newMeta.setAttribute('name', attrs.name);
        if (attrs.property) newMeta.setAttribute('property', attrs.property);
        newMeta.setAttribute('content', attrs.content);
        document.head.appendChild(newMeta);
      }
    });

    let linkCanonical = document.head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!linkCanonical) {
      linkCanonical = document.createElement('link');
      linkCanonical.setAttribute('rel', 'canonical');
      document.head.appendChild(linkCanonical);
    }
    linkCanonical.setAttribute('href', canonicalUrl);

  }, [title, description, keywords, canonicalUrl, ogType, ogImage, articlePublishedTime, articleModifiedTime, articleAuthor]);

  return null;
}